const nav = document.querySelector('.site-navbar__nav')
const toggle = document.querySelector('.site-navbar__toggle')
if(!(nav || toggle)) return

nav.querySelectorAll('a, button').forEach(el => {
  el.addEventListener('click', e => {
    nav.setAttribute('aria-expanded', 'false')
    toggle.setAttribute('aria-expanded', 'false')
  })
})